import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { DefaultSupervisionTreeComponent } from './components/default-supervision-tree/default-supervision-tree.component';
import { DefaultSupervisionAssignModalComponent } from './components/default-supervision-tree/default-supervision-assign-modal/default-supervision-assign-modal.component';
import { DefaultSupervisionContactReplacementModalComponent } from './components/default-supervision-tree/default-supervision-contact-replacement-modal/default-supervision-contact-replacement-modal.component';
import { DefaultSupervisionResolvedComponent } from './components/default-supervision-resolved/default-supervision-resolved.component';
import { PurchaseActorsPanelComponent } from './components/purchase-actors/purchase-actors-panel.component';
import { PurchaseActorNodeEditorComponent } from './components/purchase-actors/purchase-actor-node-editor.component';
import { PurchaseActorContactReplacementModalComponent } from './components/purchase-actors/purchase-actor-contact-replacement-modal.component';
import { PurchaseActorApplyModalComponent } from './components/purchase-actors/purchase-actor-apply-modal.component';
import { MatTreeModule } from '@angular/material/tree';
import { CommonModule } from '@angular/common';
import { FormModalBaseComponent } from './components/form-modal-base/form-modal-base.component';
import { DataTableBaseComponent } from './components/data-table-base/data-table-base.component';
import { FormBaseComponent } from './components/form-base/form-base.component';
import { DataTableHeaderBaseComponent } from './components/data-table-header-base/data-table-header-base.component';
import { ExtendedModule, FlexModule, GridModule } from '@ngbracket/ngx-layout';
import { IconModule } from '@abhinavakhil/iconify-angular';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatSortModule } from '@angular/material/sort';
import { DataTableColumnBaseComponent } from './components/data-table-column-base/data-table-column-base.component';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { DataTableBase } from './components/data-table-base/data-table-base';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { FormInputBaseComponent } from './components/form-input-base/form-input-base.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { FormHeaderBaseComponent } from './components/form-header-base/form-header-base.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { DataTableDropdownTemplateComponent } from './components/data-table-dropdown/content/data-table-dropdown-template.component';
import { DataTableDropdownIconComponent } from './components/data-table-dropdown/data-table-dropdown-icon.component';
import { MatBadgeModule } from '@angular/material/badge';
import { RouterModule } from '@angular/router';
import { DetailsBaseComponent } from './components/details-base/details-base.component';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { FormImportBaseComponent } from './components/form-import-base/form-import-base.component';
import { DetailsLineBaseComponent } from './components/details-line-base/details-line-base.component';
import { DetailsSkeletonBaseComponent } from './components/details-skeleton-base/details-skeleton-base.component';
import { DetailsSkeletonLineBaseComponent } from './components/details-skeleton-line-base/details-skeleton-line-base.component';
import { FormModalDeleteBaseComponent } from './components/form-modal-delete-base/form-modal-delete-base.component';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { GedBaseComponent } from './components/ged-base/ged-base.component';
import { FormModalConfirmBaseComponent } from './components/form-modal-confirme-base/form-modal-confirm-base.component';
import { FormModalConfirmWithListComponent } from './components/form-modal-confirm-with-list/form-modal-confirm-with-list.component';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { CatalogBaseComponent } from './components/catalog-base/catalog-base.component';
import { CatalogBase } from './components/catalog-base/catalog-base';
import { CatalogActionsBaseComponent } from './components/catalog-base/components/catalog-actions-base/catalog-actions-base.component';
import { CatalogBasketBaseComponent } from './components/catalog-base/components/catalog-basket-base/catalog-basket-base.component';
import { CatalogQuantityColumnBaseComponent } from './components/catalog-base/components/catalog-quantity-column-base/catalog-quantity-column-base.component';
import { CatalogSearchBarBaseComponent } from './components/catalog-base/components/catalog-search-bar-base/catalog-search-bar-base.component';
import { CatalogPerimeterSelectBaseComponent } from './components/catalog-base/components/catalog-perimeter-select-base/catalog-perimeter-select-base.component';
import { FormModalArchiveBaseComponent } from './components/form-modal-archive-base/form-modal-delete-base.component';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { ListServicesBaseComponent } from './components/list-services-base/list-services-base.component';
import { CatalogBigSearchBarBaseComponent } from './components/catalog-base/components/catalog-big-search-bar-base/catalog-big-search-bar-base.component';
import { CatalogBasketMinifiedBaseComponent } from './components/catalog-base/components/catalog-basket-minified-base/catalog-basket-minified-base.component';
import { LegendComponent } from './components/legend/legent.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { DataTableHeaderLayoutBaseComponent } from './components/data-table-header-layout-base/data-table-header-layout-base.component';
import { TextInputComponent } from './components/form-input-base/form-text-input/form-text-input.component';
import { NumberInputComponent } from './components/form-input-base/form-number-input/form-number-input.component';
import { SelectInputComponent } from './components/form-input-base/form-select-input/form-select-input.component';
import { FormErrorsComponent } from './components/form-input-base/form-input-errors/form-input-errors.component';
import { MultiSelectInputComponent } from './components/form-input-base/form-multi-input/form-multi-input.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FormSelectBetweenComponent } from './components/form-input-base/select-between/form-select-between.component';
import { FormMultiSelectSearchComponent } from './components/form-input-base/form-search-multiple/form-search-multiple.component';
import { SearchComponent } from './components/form-input-base/form-input-search/form-input-search.component';
import { SidenavBaseFilterComponent } from './components/sidenav/base-filter/sidenav-base-filter.component';
import { BannerMessageComponent } from './components/banner-message/banner-message.component';
import { BaseBannerMessageComponent } from './components/base-banner-message/base-banner-message.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { GenericReasonComponent } from './components/generic-reason/generic-reason.component';
import { QuillModule } from 'ngx-quill';
import { MetrikStatusComponent } from './components/metrik-status/metrik-status.component';
import { ButtonFilterComponent } from './components/sidenav/button-filter/button-filter.component';
import { ListCardComponent } from './components/list-card/list-card.component';
import { EmailStatusPipe } from '../pipes/email-status.pipe';
import { AppCarrouselComponent } from './components/app-carrousel/app-carrousel.component';
import { DocumentPreviewModalComponent } from './components/document-preview-modal/document-preview-modal.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { EquipmentMetrikStatusComponent } from '../../pages/application/management/equipment/equipment-details/equipment-details-resume/equipment-metrik/equipment-metrik-status.component';
import { HistoryComponent } from './components/history/history.component';
import { TruncatePipe } from '../pipes/truncate.pipe';
import { FormatAddressPipe } from '../pipes/format-address.pipe';
import { TimeAgoPipe } from '../pipes/time-ago.pipe';
import { BannerListMessageComponent } from './components/banner-list-message/banner-list-message.component';
import { FormTimeDelayInputComponent } from './components/form-input-base/form-time-delay-input/form-time-delay-input.component';
import { FormPhoneInputComponent } from './components/form-phone-input/form-phone-input.component';
import { FormListPhoneInputComponent } from './components/form-list-phone-input/form-list-phone-input.component';
import { ArchiveDeleteComponent } from './components/modal/archive-delete/archive-delete.component';
import { DeliveryAddressPickerComponent } from './components/delivery-address-picker/delivery-address-picker.component';
import { QuantityStepperComponent } from './components/quantity-stepper/quantity-stepper.component';
import { BaseTimelineComponent } from './components/base-timeline/base-timeline.component';
import { CoreModule } from '../core.module';

// Maquette d'estimation « action d'équipe » (branche d'estimation, jamais fusionnée)
import { TeamActionMockSharedModule } from '../../pages/application/administrative/team-action-mock/team-action-mock-shared.module';

@NgModule({
  declarations: [
    DataTableBase,
    DataTableBaseComponent,
    DataTableHeaderBaseComponent,
    DataTableColumnBaseComponent,
    FormBaseComponent,
    FormModalBaseComponent,
    FormHeaderBaseComponent,
    FormInputBaseComponent,
    DataTableDropdownIconComponent,
    DataTableDropdownTemplateComponent,
    DetailsBaseComponent,
    FormImportBaseComponent,
    DetailsLineBaseComponent,
    DetailsSkeletonBaseComponent,
    DetailsSkeletonLineBaseComponent,
    FormModalDeleteBaseComponent,
    FormModalArchiveBaseComponent,
    FormModalConfirmBaseComponent,
    GedBaseComponent,
    FormModalConfirmWithListComponent,
    CatalogBaseComponent,
    CatalogBase,
    CatalogActionsBaseComponent,
    CatalogBasketBaseComponent,
    CatalogBasketMinifiedBaseComponent,
    CatalogQuantityColumnBaseComponent,
    CatalogSearchBarBaseComponent,
    CatalogPerimeterSelectBaseComponent,
    CatalogBigSearchBarBaseComponent,
    ListServicesBaseComponent,
    LegendComponent,
    DataTableHeaderLayoutBaseComponent,
    FormErrorsComponent,
    TextInputComponent,
    NumberInputComponent,
    SelectInputComponent,
    MultiSelectInputComponent,
    SidenavComponent,
    FormSelectBetweenComponent,
    FormMultiSelectSearchComponent,
    SearchComponent,
    SidenavBaseFilterComponent,
    BannerMessageComponent,
    GenericReasonComponent,
    MetrikStatusComponent,
    DocumentPreviewModalComponent,
    ButtonFilterComponent,
    HistoryComponent,
    EquipmentMetrikStatusComponent,
    ListCardComponent,
    EmailStatusPipe,
    FormatAddressPipe,
    TimeAgoPipe,
    AppCarrouselComponent,
    FormTimeDelayInputComponent,
    BannerListMessageComponent,
    FormPhoneInputComponent,
    FormListPhoneInputComponent,
    ArchiveDeleteComponent,
    BaseBannerMessageComponent,
    DeliveryAddressPickerComponent,
    DefaultSupervisionTreeComponent,
    DefaultSupervisionAssignModalComponent,
    DefaultSupervisionContactReplacementModalComponent,
    DefaultSupervisionResolvedComponent,
    QuantityStepperComponent,
    PurchaseActorsPanelComponent,
    PurchaseActorNodeEditorComponent,
    PurchaseActorContactReplacementModalComponent,
    PurchaseActorApplyModalComponent,
    BaseTimelineComponent,
  ],
  exports: [
    DataTableHeaderBaseComponent,
    DataTableColumnBaseComponent,
    DataTableBaseComponent,
    FormInputBaseComponent,
    FormHeaderBaseComponent,
    FormImportBaseComponent,
    DetailsLineBaseComponent,
    DetailsSkeletonBaseComponent,
    DetailsSkeletonLineBaseComponent,
    FormModalDeleteBaseComponent,
    FormModalArchiveBaseComponent,
    GedBaseComponent,
    FormModalConfirmBaseComponent,
    CatalogBaseComponent,
    CatalogQuantityColumnBaseComponent,
    CatalogSearchBarBaseComponent,
    CatalogPerimeterSelectBaseComponent,
    CatalogBigSearchBarBaseComponent,
    CatalogBase,
    CatalogActionsBaseComponent,
    DetailsBaseComponent,
    CatalogBasketBaseComponent,
    CatalogBasketMinifiedBaseComponent,
    ListServicesBaseComponent,
    LegendComponent,
    DataTableHeaderLayoutBaseComponent,
    FormErrorsComponent,
    TextInputComponent,
    NumberInputComponent,
    SelectInputComponent,
    MultiSelectInputComponent,
    SidenavComponent,
    ButtonFilterComponent,
    FormSelectBetweenComponent,
    FormMultiSelectSearchComponent,
    SearchComponent,
    SidenavBaseFilterComponent,
    BannerMessageComponent,
    BaseBannerMessageComponent,
    GenericReasonComponent,
    MetrikStatusComponent,
    HistoryComponent,
    EquipmentMetrikStatusComponent,
    ButtonFilterComponent,
    ListCardComponent,
    EmailStatusPipe,
    FormatAddressPipe,
    TimeAgoPipe,
    ButtonFilterComponent,
    AppCarrouselComponent,
    BannerListMessageComponent,
    AppCarrouselComponent,
    FormTimeDelayInputComponent,
    AppCarrouselComponent,
    FormPhoneInputComponent,
    FormListPhoneInputComponent,
    ArchiveDeleteComponent,
    DeliveryAddressPickerComponent,
    DefaultSupervisionTreeComponent,
    DefaultSupervisionContactReplacementModalComponent,
    DefaultSupervisionResolvedComponent,
    QuantityStepperComponent,
    PurchaseActorsPanelComponent,
    PurchaseActorContactReplacementModalComponent,
    PurchaseActorApplyModalComponent,
    BaseTimelineComponent,
  ],
  imports: [
    TeamActionMockSharedModule,
    CommonModule,
    CoreModule,
    FlexModule,
    IconModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    ExtendedModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatTableModule,
    MatSortModule,
    MatMenuModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatRadioModule,
    MatDividerModule,
    MatAutocompleteModule,
    MatBadgeModule,
    RouterModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MaterialFileInputModule,
    // UiModule,
    GridModule,
    MatMomentDateModule,
    FormsModule,
    NgxMatTimepickerModule.setLocale('fr-FR'),
    NgxMatTimepickerModule,
    MatListModule,
    ScrollingModule,
    MatTabsModule,
    MatExpansionModule,
    MatChipsModule,
    MatGridListModule,
    MatCardModule,
    MatSidenavModule,
    QuillModule,
    MatProgressSpinnerModule,
    NgxExtendedPdfViewerModule,
    MatTreeModule,
  ],
  providers: [TruncatePipe],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class BaseModule {}
